export const calculateProgress = (
  setProgress: React.Dispatch<React.SetStateAction<number[]>>,
  fileIndex: number,
  loaded: number,
  total: number
) => {
  const progress = (loaded / total) * 100;
  setProgress((prevProgress: number[]) => {
    const updatedProgress = [...prevProgress];
    updatedProgress[fileIndex] = progress;
    return updatedProgress;
  });
};
